import { api } from "@/api"

const { setToken } = useMerchantGroupAuth()

export const logInMerchantGroupMagicLink = async (
  token: string
) => {
  const {
    body: { accessToken },
  } = await api.post<{
    accessToken: string
  }>("/merchant-group/handle-login-link/", {
    body: {
      token: token,
    },
    authenticated: false,
  })
  setToken(accessToken)
  return { accessToken }
}
